import React, { useState, useEffect } from 'react';
import {
  Grid,
  Typography,
  Switch,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Card,
  CardContent,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useGetSettingsQuery, useUpdateSettingsMutation } from 'state/api';
import { useSnack, SaveSnackbar } from './settingsHelper';

const DeliveryManSettings = () => {
  const { data } = useGetSettingsQuery();
  const settings = data?.data || {};
  const [updateSettings, { isLoading }] = useUpdateSettingsMutation();
  const { snack, showSuccess, showError, closeSnack } = useSnack();

  const [uploadPictureOnDelivery, setUploadPictureOnDelivery] = useState(false);
  const [forgotPasswordVerification, setForgotPasswordVerification] = useState('Email');

  useEffect(() => {
    const d = settings.custom?.deliveryMan;
    if (!d) return;
    if (d.uploadPictureOnDelivery !== undefined) setUploadPictureOnDelivery(d.uploadPictureOnDelivery);
    if (d.forgotPasswordVerification !== undefined) setForgotPasswordVerification(d.forgotPasswordVerification);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleUploadPictureOnDeliveryChange = (event) => {
    setUploadPictureOnDelivery(event.target.checked);
  };

  const handleForgotPasswordVerificationChange = (event) => {
    setForgotPasswordVerification(event.target.value);
  };

  const handleSave = async () => {
    try {
      await updateSettings({
        custom: { deliveryMan: { uploadPictureOnDelivery, forgotPasswordVerification } },
      }).unwrap();
      showSuccess();
    } catch (err) {
      showError(err?.data?.error?.message);
    }
  };

  return (
    <Card variant="outlined" sx={{ borderColor: 'divider', bgcolor: 'background.paper' }}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" color="text.primary" sx={{ display: 'flex', alignItems: 'center' }}>
              <ShoppingCartIcon sx={{ mr: 1, color: 'primary.main' }} /> Delivery Man Settings
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="body1" color="text.primary">
              Upload Picture On Delivery
              <InfoIcon color="primary" />
            </Typography>
            <Switch checked={uploadPictureOnDelivery} onChange={handleUploadPictureOnDeliveryChange} />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="body1" color="text.primary">
              Forgot Password Verification By
              <InfoIcon color="primary" />
            </Typography>
            <RadioGroup
              row
              aria-labelledby="forgot-password-verification-group"
              value={forgotPasswordVerification}
              onChange={handleForgotPasswordVerificationChange}
            >
              <FormControlLabel value="Email" control={<Radio />} label="Email" />
              <FormControlLabel value="Phone (OTP)" control={<Radio />} label="Phone (OTP)" />
            </RadioGroup>
          </Grid>

          <Grid item xs={12}>
            <Button variant="contained" color="primary" fullWidth onClick={handleSave} disabled={isLoading}>
              {isLoading ? 'Saving...' : 'Save'}
            </Button>
          </Grid>
        </Grid>

        <SaveSnackbar snack={snack} onClose={closeSnack} />
      </CardContent>
    </Card>
  );
};

export default DeliveryManSettings;
